import { Outlet, useLoaderData } from "react-router-dom";

import Loading from "@/components/layout/loading";
import Resolver from "@/components/resolver";
import { hasProjectSucceeded } from "@/utils";
import Empty from "./empty";
import Processed from "./processed";
import Unprocessed from "./unprocessed";

const Resolved = ({ project, statements }) => {
  return (
    <div className="flex size-full flex-col">
      <div className="flex-1">
        {hasProjectSucceeded(project) ? (
          <Processed project={project}>
            <Outlet context={{ project }} />
          </Processed>
        ) : (
          <>
            <Empty project={project} statements={statements} />
            <Unprocessed project={project} statements={statements} />
            <Outlet context={{ project, statements }} />
          </>
        )}
      </div>
    </div>
  );
};

export default function ShowView() {
  const { project, projectStatements } = useLoaderData();

  return (
    <>
      <Resolver fallback={<Loading />} resolve={project}>
        {(project) => (
          <Resolver fallback={<Loading />} resolve={projectStatements}>
            {(statements) => (
              <Resolved project={project} statements={statements} />
            )}
          </Resolver>
        )}
      </Resolver>
    </>
  );
}
